import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  numberAttribute,
} from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

/**
 * A loading placeholder: a block (`rect`), a circle, or `lines` lines of text
 * (the last one shorter).
 *
 *   <sh-skeleton width="160px" height="1rem" />
 *   <sh-skeleton shape="circle" width="2.5rem" />
 *   <sh-skeleton [lines]="3" />
 */
@Component({
  selector: 'sh-skeleton',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [CommonModule, SkeletonModule],
  template: `
    <p-skeleton
      *ngIf="!lineWidths().length; else textLines"
      [shape]="shape() === 'circle' ? 'circle' : 'rectangle'"
      [width]="width()"
      [height]="shape() === 'circle' ? width() : height()"
    ></p-skeleton>
    <ng-template #textLines>
      <div class="sh-skeleton-lines">
        <p-skeleton
          *ngFor="let lineWidth of lineWidths()"
          [width]="lineWidth"
          [height]="height()"
        ></p-skeleton>
      </div>
    </ng-template>
  `,
})
export class ShSkeletonComponent {
  readonly width = input('100%');
  readonly height = input('1rem');
  readonly shape = input<'rect' | 'circle'>('rect');
  /** Renders this many text lines instead of one block. */
  readonly lines = input(0, { transform: numberAttribute });

  protected readonly lineWidths = computed(() => {
    const count = Math.max(0, Math.floor(this.lines()));
    return Array.from({ length: count }, (_, i) =>
      count > 1 && i === count - 1 ? '60%' : this.width()
    );
  });
}
